import {useState} from "react";
import {useShareFilters} from "../../../../hooks";
import {useContextSelector} from "use-context-selector";
import {CommonFiltersSavedContext} from "../../../../context";

export default function useSavedFilters() {
    const {buildFilterParams } = useShareFilters()
    const page = useContextSelector(CommonFiltersSavedContext, ({state}) => state.page)
    const [name, setName] = useState('')

    return {
        name, setName, buildFilterParams, page
    }
}